/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import stats from "stats";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import React, { useState, useEffect } from "react";
// Material Kit 2 React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";
import { useTranslation } from "react-i18next";
/* eslint-disable react/prop-types */
// eslint-disable-next-line
const CountersMuni = ({ selectedKunta, setSelectedKunta }) => {
  const [t] = useTranslation("common");
  const [selectedStats, setSelectedStats] = useState(
    stats.filter((kunta) => kunta.Kunta === "Siikainen")[0]
  ); // Valittu alue
  //console.log(selectedKunta);
  //console.log(setSelectedKunta);
  //console.log(selectedStats);
  //console.log(setSelectedStats);
  //console.log(stats);

  useEffect(() => {
    setSelectedStats(stats.filter((kunta) => kunta.Kunta === selectedKunta)[0]);
  }, [selectedKunta]);
  useEffect(() => {
    setSelectedStats(stats.filter((kunta) => kunta.Kunta === selectedKunta)[0]);
  }, []);
  return (
    <MKBox component="section" py={3}>
      <Container>
        <MKTypography variant="h2" color="dark" textAlign="center" px={{ xs: 6, lg: 12 }} mt={1}>
          {selectedKunta}
        </MKTypography>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={selectedStats.Vakiluku}
              suffix=""
              title={t("common.population")}
              description={t("common.populationtext")}
            />
          </Grid>
          <Grid item xs={12} md={4} display="flex">
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
            <DefaultCounterCard
              count={selectedStats.Syntyneiden_enemmyys}
              suffix=""
              title={t("common.birthmore")}
              description={t("common.birthmoretext")}
            />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, ml: 0 }} />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={selectedStats.Muuttovoitto}
              suffix=""
              title={t("common.migration")}
              description={t("common.migrationtext")}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={selectedStats.Taloudellinen_huoltosuhde}
              suffix="%"
              title={t("common.economy")}
              description={t("common.economytext")}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={selectedStats.Taajamaa}
              suffix="%"
              title={t("common.urban")}
              description={t("common.urbantext")}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={selectedStats.Vuokra_asunnoissa_asuvia_asuntokuntia}
              suffix="%"
              title={t("common.rent")}
              description={t("common.renttext")}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={selectedStats.Toisen_asteen_tutkinnon_suorittaneita_15v}
              suffix="%"
              title={t("common.secondschool")}
              description={t("common.secondschooltext")}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={selectedStats.Korkeaasteen_tutkinnon_suorittaneita15v}
              suffix="%"
              title={t("common.highlevelschool")}
              description={t("common.highlevelschool")}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={selectedStats.Tyopaikkaomavaraisuus}
              suffix="%"
              title={t("common.work")}
              description={t("common.worktext")}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={selectedStats.Ika20_64v_tyollisyysaste}
              suffix="%"
              title={t("common.workrate")}
              description={t("common.workratetext")}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={selectedStats.Elakelaisia}
              suffix="%"
              title={t("common.pension")}
              description={t("common.pensiontext")}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
};

export default CountersMuni;
